<template>
<div class="chapter">
<div class="inner_page">
<p><a id="ack"></a></p>
<div class="fmhT"><b>Acknowledgments</b></div>
<div class="fmtx1">We thank Michael J. Pfister, assistant superintendent of South River Public Schools, Kevin W. Kidney, principal of South River High School, Paul J. Coleman, assistant principal of South River High School, Geraldine Misiewicz, math supervisor, and our colleagues for their support of our writing.</div>
<div class="fmtx">Thanks also to Steve D. Thompson, our editor, for his support of our efforts to complete this second edition.</div>
<div class="fmtx">Special thanks to Caroline Fitzgerald and Geri Priest, who read the original manuscript and offered many helpful suggestions, to Jamie Egan for helping us better understand the mathematical aspects of music, and Colleen Duffey Shoup as well as Dover Clip-Art for the illustrations.</div>
<div class="fmtx">We greatly appreciate the help and encouragement of Susan Kolwicz, whose advice on the first edition enabled us to take our rough ideas and fashion them into a practical resource for teachers.</div>
<div class="fmtx">We are indebted to Sonia Helton, professor of education at the University of South Florida, for her insightful recommendations for the projects in this book.</div>
<div class="fmtx">We want to thank our daughter, Erin, who read the first draft of this new edition from the perspective of a young math teacher and caught several oversights and omissions.</div>
<div class="fmtx">And finally, we thank our students. In the end, they are why all of us are in this business.</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// musc_9781118040942_oeb_ack_r1.vue?4e562974